import {PageContent, Typography, Divider} from '@genestack/ui';
import React from 'react';

import {Preloader} from '../../../../components/preloader/preloader';
import {Sidebar} from '../../../../components/layout/sidebar';

import {DocumentLink} from './document-link';
import {useListFavoritesQuery} from './explore-favorites-query';
import {SidebarHeader} from '../../../../components/layout/sidebar/sidebar-header/sidebar-header';
import {ExploreDocumentsSidebarProps} from './interface';

function FavoritesResults(props: {
    items: ViewModeDoc[];
    selectedDocumentId?: string;
    getDocumentLink: (documentId: string) => string;
}) {
    return (
        <>
            {props.items.map((docInfo) => (
                <DocumentLink
                    key={docInfo.accession}
                    documentId={docInfo.accession}
                    active={docInfo.accession === props.selectedDocumentId}
                    displayFavoriteState={false}
                    getDocumentLink={props.getDocumentLink}
                    docInfo={docInfo}
                />
            ))}
        </>
    );
}

export const FavoriteDocumentsSidebar = (props: ExploreDocumentsSidebarProps) => {
    const selectedDocumentId = props.documentId;

    const listFavoritesQuery = useListFavoritesQuery(props.selectedGlobalVersion.id);
    const items = listFavoritesQuery.data;

    const header = <SidebarHeader title="Bookmarks" onClose={props.closeSidebar} />;

    return (
        <Sidebar header={header} footer={props.footer} border="right">
            <Preloader show={listFavoritesQuery.isFetching}>
                {!listFavoritesQuery.isSuccess || !items?.length ? (
                    <PageContent noStartDivider noEndDivider>
                        <Typography intent="quiet">
                            You haven't bookmarked any documents yet
                        </Typography>
                    </PageContent>
                ) : (
                    <>
                        <FavoritesResults
                            items={items}
                            selectedDocumentId={selectedDocumentId}
                            getDocumentLink={props.getDocumentLink}
                        />
                        <Divider
                            variant="transparent"
                            gap={4} // tslint:disable-line: no-magic-numbers
                        />
                    </>
                )}
            </Preloader>
        </Sidebar>
    );
};
